module.exports = __webpack_public_path__ + "static/media/icon_data_da_sessao.2bab43eb.svg";